<template>
    <v-form ref="userReplacementForm" :value="isFormValid" lazy-validation>
        <v-card>
        
            <div>
                <v-alert dismissible :value="successVisible" type="success" transition="slide-y-transition">{{this.alertMessage}}</v-alert>
                <v-alert dismissible :value="errorVisible" type="error" transition="slide-y-transition">{{this.alertMessage}}</v-alert>
            </div>
        
        <v-card-title>Bulk Management Contact Replacement</v-card-title>
        <v-card-text>
            <v-row>
            <v-col cols="3">
                <v-combobox  label="User to replace" v-model="replacement.curretUser" :items="users" 
                    :rules="[v=>!!v || 'User to replace is required']" required>
                    <template #label>User to replace<span class="red--text"> <strong>*</strong></span></template>
                </v-combobox>
            </v-col>
            <v-col cols="3">
                <v-combobox  label="User Asigned" v-model="replacement.replacementUsers" :items="users"
                    :return-object="true" @change="onUserAsignedChange" :rules="[v=>!!v || 'User Asigned']"
                     required
                     multiple>
                    <template #label>User Asigned <span class="red--text"> <strong>*</strong> </span></template>
                </v-combobox>
                <v-dialog v-model="isNewUserDialogVisible" persistent >
                    <NewUser :userName="newUserName" @saved="newUserAdded" @canceled="newUserCancel"></NewUser>
                </v-dialog>
            </v-col>
            
            <v-col cols="2" >
                <!--
                    <v-tooltip bottom>
                    <template v-slot:activator="{on, attrs}">
                    <a dense class="ma-2" target="_blank" @click="onAddingNewUser"  > 
						<v-icon v-bind="attrs" v-on="on" color="primary">mdi-account-plus</v-icon>
					</a>            
                    </template>
                    <span>Add a new user</span>            
                </v-tooltip>
                -->
                
                <v-btn color="success ma-2" @click="onReplacingUser" align-self="flex-start">
                    <v-icon>mdi-content-save</v-icon>Replace User
                </v-btn>
                <ConfirmationPanel :isVisible="isConfirmVisible" :message="confirmMessage" @confirm:click="onUserReplacementConfirmed"></ConfirmationPanel>
            </v-col>
            </v-row>
        </v-card-text>
    </v-card>

    </v-form>
    
</template>
<script>
    import userAPI from '@/services/userservice';


    export default{
        name:'UserReplacement',
        components:{
            NewUser:()=>import("./NewUser.vue"),
            ConfirmationPanel:()=>import('@/views/commond/ConfirmationPanel')
        },
        data: function(){
            return {
                users:[],
                isNewUserDialogVisible:false,
                newUserName:'',
                successVisible:false,
                errorVisible:false,
                alertMessage:'',
                isFormValid:false,
                isConfirmVisible:false,
                confirmMessage:'',
                replacement:{
                    curretUser:null,
                    replacementUsers:null
                }
            }
        },
        mounted: async function(){
            await this.loadUsers();
        },
        methods:{
            async loadUsers(){
                await userAPI.getUsers()
                .then(response=>{
                    response.data.map((user)=>{
                        this.users.push({value: user.userId, text: user.name});
                    })})
                .catch(error=>{
                    console.log(error);
                })
            },
            async onAddingNewUser(){
                this.isNewUserDialogVisible=true;
            },
            async onUserAsignedChange(dropBox){
                if(typeof(dropBox)==='string' && dropBox.trim())
                {
                           
                    var value=dropBox;
                    console.log('value', dropBox);
                    this.newUserName=value;
                    const item=this.users.find(user=>user.value===value);
                    if(item){
                        this.replacement.curretUser={value:item.value, text: item.text };     
                    } else{ 
                        this.isNewUserDialogVisible=true;   
                    }
                }   
            },
            
            async newUserAdded(isSaved,message, newUser){
                console.log('new USer',newUser.userId);
                if(isSaved)
                {
                  this.successVisible=true;
                  await this.loadUsers();
                  this.replacement.replacementUser={value: newUser.userId, text: newUser.name};
                }
                else
                  this.errorVisible=true;

                this.alertMessage=message;
                this.isNewUserDialogVisible=false;
                
                
                this.hideAlert();
            },
            async newUserCancel(value){
                this.errorVisible=value;
                this.alertMessage='Adding User was canceled';
                this.isNewUserDialogVisible=false;
                this.hideAlert();
            },
            hideAlert: function(){
             window.setInterval(()=>{
                this.successVisible=false;
                this.errorVisible=false;
                },10000);
            },
            onReplacingUser(){
                if(this.replacement.replacementUsers.length<1)
                {
                    this.$emit('replacement:click', false,'New User(s) must be selected.');
                    return;
                }
                this.isFormValid=this.$refs.userReplacementForm.validate();
                if(this.isFormValid){
                    this.confirmMessage="Bulk User Replace confirmation";
                    this.isConfirmVisible=true;
                }
            },
            async onUserReplacementConfirmed(value){
                this.isConfirmVisible=false;
                if(value){
                    await this.replaceUser();
                }
            },
            async replaceUser()
            {
                console.log('Replacement ',this.replacement);
                this.isFormValid=this.$refs.userReplacementForm.validate();
                if(this.isFormValid)
                {
                    let newUsers=[];
                    this.replacement.replacementUsers.map((user)=>{
                        newUsers.push(user.value);
                    });
                    const bodyReplace={
                    currentUser:this.replacement.curretUser.value,
                    replacementUsers:newUsers
                    }
                    console.log("bodyReplace: ",bodyReplace);
                    await userAPI.replaceUser(bodyReplace)
                    .then(response=>{
                        console.log(response);
                        this.$emit('replacement:click', true,
                        `User ${this.replacement.curretUser.text} has been replaced.`);
                        
                    })
                    .catch(error=>{
                        console.log(error);
                        this.$emit('replacement:click', false,'replacement could not be done.');
                    })
                }  
            }
            
    }

    }
</script>